// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';

export const pagesQuerySchema = z.object({
  id: z.union([idSchema, z.array(idSchema)]),
  annotation: z.union([idSchema, z.array(idSchema)]),
  number: z.union([z.number(), z.array(z.number())]),
});
